import { RootState } from 'models';

const getProgramCode = (state: RootState) => state.app.programCode;

const getProgramName = (state: RootState) => state.app.programName;

const getCompanyCode = (companyName: string, state: RootState): number | undefined => {
  const company = state.app.companies.find(({ name }) => companyName === name);
  if (company) return company.idCompany;
};

const getConfig = (state: RootState, config: string, defaultValue?: any) =>
  state.app.config[config] || { val: defaultValue ?? 1 };

const isActionByConfigActive = (state: RootState, companyName: string, type: string) => {
  const { isForCompany, val, CompanyConf } = getConfig(state, type);
  return (!isForCompany ? val : CompanyConf[companyName]) === 1;
};

const isActionByCompanyActive = (state: RootState, companyName: string, type: string): boolean => {
  const company = state.app.companies.find(({ name }) => companyName === name);
  return company?.actions.find((action) => action.type === type)?.active ? true : false;
};

const getBuildNumber = (state: RootState): string => state.app.style.buildNumber;

const getAppStyle = (state: RootState) => state.app.style;

const getCompanies = (state: RootState) => state.app.companies;

const getCompaniesDocTypeUser = (state: RootState) => state.app.companiesDocTypeUser;

const getMenu = (state: RootState) => state.app.isMenuOpen;

const getScreenWidth = (state: RootState) => state.app.screenWidth;

const getDisabledDropdown = (state: RootState) => state.app.disabledDropdown;

const getProgramUrl = (state: RootState) => state.app.programUrl;

export const getHeaderExpanded = (state: RootState): boolean => state.app.isHeaderExpanded;

export default {
  getProgramCode,
  getProgramName,
  getCompanyCode,
  getMenu,
  getCompanies,
  getAppStyle,
  getBuildNumber,
  isActionByCompanyActive,
  isActionByConfigActive,
  getConfig,
  getCompaniesDocTypeUser,
  getScreenWidth,
  getDisabledDropdown,
  getProgramUrl,
  getHeaderExpanded,
};
